// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"cfdce510","496":"528987d5"}[chunkId] + ".chunk.js";
};